import React from 'react'
import { Row, Col, Button, Input, InputNumber } from 'antd'
import {
  CheckCircleOutlined,
  SyncOutlined,
  CloseCircleOutlined,
  NumberOutlined,
  TagsOutlined,
  FieldNumberOutlined,
  ProfileOutlined,
  DollarOutlined,
  FieldTimeOutlined,
  CommentOutlined
} from '@ant-design/icons'
import { numberOnly } from './utils'

const inputStyle = { width: 180, height: 40, fontSize: 15 }
const commentStyle = { width: 250, height: 40, fontSize: 15 }
const equivInputStyle = { width: 200, height: 40, fontSize: 15 }
const equivCommentStyle = { width: 260, height: 40, fontSize: 15 }
const equivDescStyle = { width: 500, minHeight: 40, fontSize: 15 }

const ArticleResponseCard = ({
  item,
  response,
  handleItemChange,
  getSelectedCurrencyCode,
}) => (
  <div style={{
    borderBottom: '1px solid #f0f0f0',
    padding: 18,
    paddingBottom: 26,
  }}>
    {/* Top: details + response options */}
    <Row gutter={8} align="middle" style={{ marginBottom: 10 }}>
      <Col xs={24} md={8}>
        <b style={{ fontSize: 15 }}>{item.name || 'Article'}</b>
        <div style={{ fontSize: 14, color: '#888' }}>
          {item.brand && (
            <div>
              <b>Marque:</b> {item.brand}
            </div>
          )}
          {item.description && (
            <div>
              <b>Description:</b> {item.description}
            </div>
          )}
        </div>
      </Col>
      <Col xs={12} md={4}>
        <span style={{ fontWeight: 500, fontSize: 14 }}>Quantité demandée:</span>{' '}
        <span style={{ fontSize: 15 }}>{item.quantity}</span>
      </Col>
      <Col xs={24} md={12} style={{ textAlign: 'right' }}>
        <Button
          className="response-option-btn response-available"
          type={response.is_available === true ? 'primary' : 'default'}
          icon={<CheckCircleOutlined />}
          onClick={() =>
            handleItemChange(item.id, 'is_available', true)
          }
          style={{
            background:
              response.is_available === true ? '#389e0d' : undefined,
            borderColor: '#389e0d',
            color:
              response.is_available === true ? '#fff' : '#389e0d',
            fontWeight: 400,
            marginRight: 12,
            fontSize: 15,
            height: 40
          }}
        >
          Disponible
        </Button>
        <Button
          className="response-option-btn response-not-available"
          type={response.is_available === false ? 'primary' : 'default'}
          icon={<CloseCircleOutlined />}
          onClick={() =>
            handleItemChange(item.id, 'is_available', false)
          }
          style={{
            background:
              response.is_available === false ? '#d4380d' : undefined,
            borderColor: '#d4380d',
            color:
              response.is_available === false ? '#fff' : '#d4380d',
            fontWeight: 400,
            marginRight: 12,
            fontSize: 15,
            height: 40
          }}
        >
          Non disponible
        </Button>
        <Button
          className="response-option-btn response-alternative"
          type={response.has_alternative ? 'primary' : 'default'}
          icon={<SyncOutlined />}
          onClick={() =>
            handleItemChange(
              item.id,
              'has_alternative',
              !response.has_alternative,
            )
          }
          style={{
            background: response.has_alternative
              ? '#faad14'
              : undefined,
            borderColor: '#faad14',
            color: response.has_alternative ? '#fff' : '#faad14',
            fontWeight: 400,
            fontSize: 15,
            height: 40
          }}
        >
          Équivalent
        </Button>
      </Col>
    </Row>
    {/* Original Article Card */}
    {response.is_available === true && (
      <div className="original-article-box">
        <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 7, display: 'flex', alignItems: 'center', color: '#389e0d' }}>
          <CheckCircleOutlined style={{ marginRight: 7, fontSize: 18 }} />
          Article Original
        </div>
        <div
          className="article-inputs-row"
          style={{
            display: 'flex',
            gap: 18,
            alignItems: 'flex-end',
            flexWrap: 'wrap',
            marginBottom: 4,
          }}
        >
          <div className="article-input-wrap">
            <label><NumberOutlined /> Quantité Disponible</label>
            <InputNumber
              min={1}
              value={response.available_quantity}
              onChange={(v) =>
                handleItemChange(item.id, 'available_quantity', v)
              }
              style={inputStyle}
              placeholder="Quantité dispo"
              onKeyDown={numberOnly}
            />
          </div>
          <div className="article-input-wrap">
            <label><DollarOutlined /> Prix Unitaire ({getSelectedCurrencyCode()})</label>
            <InputNumber
              min={0}
              step={0.01}
              value={response.quoted_unit_price}
              onChange={(v) =>
                handleItemChange(item.id, 'quoted_unit_price', v)
              }
              style={inputStyle}
              placeholder="Prix unitaire"
              onKeyDown={numberOnly}
            />
          </div>
          <div className="article-input-wrap">
            <label><DollarOutlined /> Prix Total ({getSelectedCurrencyCode()})</label>
            <InputNumber
              value={response.quoted_total_price}
              readOnly
              style={inputStyle}
              placeholder="Prix total"
              onKeyDown={numberOnly}
            />
          </div>
          <div className="article-input-wrap">
            <label><FieldTimeOutlined /> Délai livraison (jours)</label>
            <InputNumber
              min={1}
              value={response.delivery_time}
              onChange={(v) =>
                handleItemChange(
                  item.id,
                  'delivery_time',
                  v,
                )
              }
              style={inputStyle}
              placeholder="Délais"
              onKeyDown={numberOnly}
            />
          </div>
          <div className="article-input-wrap">
            <label><CommentOutlined /> Commentaires</label>
            <Input
              value={response.vendor_comments}
              onChange={(e) =>
                handleItemChange(
                  item.id,
                  'vendor_comments',
                  e.target.value,
                )
              }
              placeholder="Commentaires"
              style={commentStyle}
            />
          </div>
        </div>
      </div>
    )}
    {/* Equivalent Article Card */}
    {response.has_alternative && (
      <div className="equivalent-article-box">
        <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 7, display: 'flex', alignItems: 'center', color: '#faad14' }}>
          <SyncOutlined style={{ marginRight: 7, fontSize: 18 }} />
          Article Équivalent
        </div>
        <Row gutter={24} style={{ marginBottom: 4 }}>
          <Col>
            <div className="article-input-wrap" style={{ minWidth: 220 }}>
              <label style={{ fontSize: 15 }}><ProfileOutlined /> Référence de l'article équivalent *</label>
              <Input
                value={response.alternative_reference}
                onChange={(e) =>
                  handleItemChange(
                    item.id,
                    'alternative_reference',
                    e.target.value,
                  )
                }
                required
                style={equivInputStyle}
              />
            </div>
          </Col>
          <Col>
            <div className="article-input-wrap" style={{ minWidth: 220 }}>
              <label style={{ fontSize: 15 }}><TagsOutlined /> Marque</label>
              <Input
                value={response.alternative_brand}
                onChange={(e) =>
                  handleItemChange(
                    item.id,
                    'alternative_brand',
                    e.target.value,
                  )
                }
                required
                style={equivInputStyle}
              />
            </div>
          </Col>
          <Col>
            <div className="article-input-wrap" style={{ minWidth: 220 }}>
              <label style={{ fontSize: 15 }}><FieldNumberOutlined /> Quantité Disponible</label>
              <InputNumber
                min={1}
                value={response.alternative_quantity}
                onChange={(v) =>
                  handleItemChange(
                    item.id,
                    'alternative_quantity',
                    v,
                  )
                }
                style={equivInputStyle}
                onKeyDown={numberOnly}
              />
            </div>
          </Col>
        </Row>
        <Row style={{ marginBottom: 12 }}>
          <Col span={24}>
            <div className="article-input-wrap">
              <label style={{ fontSize: 15 }}><ProfileOutlined /> Description *</label>
              <Input.TextArea
                value={response.alternative_description}
                onChange={(e) =>
                  handleItemChange(
                    item.id,
                    'alternative_description',
                    e.target.value,
                  )
                }
                required
                rows={2}
                style={equivDescStyle}
              />
            </div>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col>
            <div className="article-input-wrap" style={{ minWidth: 220 }}>
              <label style={{ fontSize: 15 }}><DollarOutlined /> Prix Unitaire ({getSelectedCurrencyCode()})</label>
              <InputNumber
                min={0}
                step={0.01}
                value={response.alternative_unit_price}
                onChange={(v) =>
                  handleItemChange(
                    item.id,
                    'alternative_unit_price',
                    v,
                  )
                }
                style={equivInputStyle}
                onKeyDown={numberOnly}
              />
            </div>
          </Col>
          <Col>
            <div className="article-input-wrap" style={{ minWidth: 220 }}>
              <label style={{ fontSize: 15 }}><DollarOutlined /> Prix Total ({getSelectedCurrencyCode()})</label>
              <InputNumber
                value={response.alternative_total_price}
                readOnly
                style={equivInputStyle}
                onKeyDown={numberOnly}
              />
            </div>
          </Col>
          <Col>
            <div className="article-input-wrap" style={{ minWidth: 220 }}>
              <label style={{ fontSize: 15 }}><FieldTimeOutlined /> Délai livraison (jours)</label>
              <InputNumber
                min={1}
                value={response.alternative_delivery_time}
                onChange={(v) =>
                  handleItemChange(
                    item.id,
                    'alternative_delivery_time',
                    v,
                  )
                }
                style={equivInputStyle}
                onKeyDown={numberOnly}
              />
            </div>
          </Col>
          <Col>
            <div className="article-input-wrap" style={{ minWidth: 260 }}>
              <label style={{ fontSize: 15 }}><CommentOutlined /> Commentaires</label>
              <Input
                value={response.alternative_comments}
                onChange={(e) =>
                  handleItemChange(
                    item.id,
                    'alternative_comments',
                    e.target.value,
                  )
                }
                style={equivCommentStyle}
              />
            </div>
          </Col>
        </Row>
      </div>
    )}
  </div>
)

export default ArticleResponseCard
